module.exports = __webpack_public_path__ + "img/Zadeh-Case-Study-600px.1cb1eced.jpeg";